import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero, Eyebrow } from "../components/Section";
import { SPEAKING_TOPICS, SPEAKING_FORMATS } from "../lib/content";

export default function Speaking() {
  return (
    <div data-testid="speaking-page">
      <PageHero
        eyebrow="Speaking & Training"
        num="01"
        title={<>High-impact sessions on <span className="italic text-[var(--bjc-gold)]">financial crime,</span> AML, and emerging risks.</>}
        intro="From keynote addresses at global forums to in-house, scenario-driven training — engagements are calibrated to the audience and delivered first-hand by the practitioner."
      />

      {/* Topics */}
      <section className="bjc-section border-b border-[var(--bjc-border)]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <Eyebrow num="02">Topics</Eyebrow>
            <h2 className="mt-6 font-serif-display text-3xl md:text-5xl leading-[1.05] text-[var(--bjc-text)]">
              Speaking topics.
            </h2>
          </div>
          <div className="md:col-span-7 md:col-start-6">
            <ul className="divide-y divide-[var(--bjc-border)] border-y border-[var(--bjc-border)]">
              {SPEAKING_TOPICS.map((t, i) => (
                <li
                  key={t}
                  data-testid={`speaking-topic-${i}`}
                  className="py-6 flex items-start gap-6 group"
                >
                  <span className="bjc-numeral pt-1">0{i + 1}</span>
                  <span className="text-xl md:text-2xl font-serif-display text-[var(--bjc-text)] group-hover:text-[var(--bjc-gold)] transition-colors">
                    {t}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Formats */}
      <section className="bjc-section">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12">
            <div className="md:col-span-4">
              <Eyebrow num="03">Formats</Eyebrow>
            </div>
            <div className="md:col-span-8">
              <h2 className="font-serif-display text-3xl md:text-5xl leading-[1.05] text-[var(--bjc-text)] max-w-[22ch]">
                From boardrooms to global stages.
              </h2>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[var(--bjc-border)] border border-[var(--bjc-border)]">
            {SPEAKING_FORMATS.map((f, i) => (
              <div key={f.title} data-testid={`speaking-format-${i}`} className="bjc-card p-10 md:p-12 min-h-[220px]">
                <span className="bjc-numeral">— 0{i + 1}</span>
                <h3 className="mt-4 font-serif-display text-2xl md:text-3xl text-[var(--bjc-text)]">{f.title}</h3>
                <p className="mt-4 text-[var(--bjc-text-muted)] leading-relaxed">{f.body}</p>
              </div>
            ))}
          </div>

          <div className="mt-16 text-center">
            <Link to="/contact" data-testid="speaking-cta" className="bjc-btn-primary">
              Invite Bharat to Speak <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
